<script lang="ts">
import {defineComponent, onMounted, PropType, reactive, ref, watch,} from 'vue'
import {useI18n} from 'vue-i18n'
import {toRefs} from '@vueuse/core'
import VModal from '/@src/components/base/modal/VModal.vue'
import NotificationForm, {
  NotificationFormData,
  NotificationType
} from "/@src/components/pages/forms/content/NotificationForm.vue";
import useNotyf from "/@src/composable/useNotyf";

export default defineComponent({
  components: {
    NotificationForm,
    VModal,
  },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    contentId: {
      type: Number,
      default: -1,
    },
    title: {
      type: String,
      default: '',
    },
    content: {
      type: String,
      default: '',
    },
    notificationType:{
      type: String as PropType<NotificationType>,
      default:'article'
    },
    /**
     * 是否可选择推送类型
     */
    showTypeOption: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:open'],
  setup(props, { slots, attrs, emit }) {
    const { t } = useI18n()
    const propsData = toRefs(props)
    const notify = useNotyf()
    const isLoading = ref(false)
    const notificationFormElement = ref(null)
    const param = reactive({
      title:'',
      content:'',
      id:-1
    })
    onMounted(()=>{
      param.id=props.contentId
      param.title=props.title
      param.content=props.content
    })
    const handleClose = () => {
      emit('update:open', false)
      // notificationFormElement.value?.reset()
    }
    const handleClickSend = () =>{
      if(notificationFormElement.value?.isNotificationValid()){
        isLoading.value = true
        notificationFormElement.value?.sendNotification(param.id).then(res=>{
          notify.success(t('event-notification-success'))
          handleClose()
        }).finally(()=>{
          isLoading.value = false
        })
      }
    }
    watch(propsData.open,()=>{
      if(props.open){
        param.id = props.contentId
        param.title = props.title
        param.content = props.content
        const notificationForm:NotificationFormData = {
          id: props.contentId,
          title:props.title,
          content:props.content
        }
        notificationFormElement.value?.setNotificationData(notificationForm)
      }
    })
    const setId = (id:number)=>{
      param.id = id
    }
    const setTitle = (title:string)=>{
      param.title = title
    }
    const setContent = (content:string)=>{
      param.content = content
    }
    return {
      param,
      isLoading,
      setId,
      setTitle,
      setContent,
      handleClose,
      handleClickSend,
      notificationFormElement,
      t
    }
  },
})
</script>
<template>
  <V-Modal
    :open="open"
    :title="t('title-notification-dialog')"
    actions="right"
    size="big"
    @close="handleClose"
  >
    <template #content>
      <notification-form
        ref="notificationFormElement"
        :showTypeOption="showTypeOption"
        :showNotificationCheck="false"
        :showFormTitle="false"
        :initType="notificationType"
        :title="param.title"
        :content="param.content"
        class="wrapper-form"/>
    </template>
    <template #action>
      <V-Button
        :loading="isLoading"
        v-t="'action-confirm'"
        color="primary"
        raised
        @click="handleClickSend"
      ></V-Button>
    </template>
    <template #background>
    </template>
  </V-Modal>
</template>
<style lang="scss">
@import '../../scss/abstracts/_variables.scss';
@import '../../scss/abstracts/_mixins.scss';
@import '../../scss/components/dropdowns';
.is-dark{
  .v-modal{
    .modal-background{
      background: hsla(var(--dark-sidebar-h), var(--dark-sidebar-s), var(--dark-sidebar-l), 0.8) !important;
    }
  }
}
.v-modal{
  .modal-background{
    backdrop-filter: blur(8px);
  }
}
.wrapper-form{
  min-height: 450px;
}
</style>
